import { route } from "react-router-typesafe-routes";

export const DASHBOARD_ROUTES = {
  ROOT: route({
    path: "dashboards",
    children: {
      DETAIL: route({ path: ":name" }),
    },
  }),
};
